var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 2C11.9235 2 8.6531 3.35463 6.24185 5.76588C3.83059 8.17714 2.47596 11.4475 2.47596 14.8575V22.5421L0.960916 24.0571C0.661315 24.3568 0.457295 24.7386 0.374648 25.1542C0.292 25.5698 0.334437 26.0006 0.496592 26.3921C0.658747 26.7837 0.93334 27.1183 1.28566 27.3538C1.63797 27.5893 2.0522 27.715 2.47596 27.7151H28.191C28.6148 27.715 29.029 27.5893 29.3813 27.3538C29.7337 27.1183 30.0082 26.7837 30.1704 26.3921C30.3326 26.0006 30.375 25.5698 30.2923 25.1542C30.2097 24.7386 30.0057 24.3568 29.7061 24.0571L28.191 22.5421V14.8575C28.191 11.4475 26.8364 8.17714 24.4251 5.76588C22.0139 3.35463 18.7435 2 15.3335 2ZM15.3335 36.2868C13.6285 36.2868 11.9933 35.6094 10.7877 34.4038C9.58204 33.1982 8.90473 31.563 8.90473 29.858H21.7623C21.7623 31.563 21.0849 33.1982 19.8793 34.4038C18.6737 35.6094 17.0385 36.2868 15.3335 36.2868Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3819,
    cy: 6.28584,
    r: 5.95268,
    fill: "#F65B2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellNotification);
export default __webpack_public_path__ + "static/media/bell-notification.e501121d4dedf2f92b5e9164d987c164.svg";
export { ForwardRef as ReactComponent };